import {
  CHANGE_LOCALE,

  ALL_CATEGORY_FETCH,
  ALL_CATEGORY_FETCH_SUCCESS,
  ALL_CATEGORY_FETCH_FAIL,

  EXTERNAL_CATEGORY_FETCH,
  EXTERNAL_CATEGORY_FETCH_SUCCESS,
  EXTERNAL_CATEGORY_FETCH_FAIL,

  ALL_SUBCATEGORY_FETCH,
  ALL_SUBCATEGORY_FETCH_SUCCESS,
  ALL_SUBCATEGORY_FETCH_FAIL,

  HELP_FETCH,
  HELP_FETCH_SUCCESS,
  HELP_FETCH_FAIL,

  HELP_DETAIL_FETCH,
  HELP_DETAIL_FETCH_SUCCESS,
  HELP_DETAIL_FETCH_FAIL,

  POLICY_LIST_FETCH,
  POLICY_LIST_FETCH_SUCCESS,
  POLICY_LIST_FETCH_FAIL,

  SEARCH_HELP_LIST_FETCH,
  SEARCH_HELP_LIST_FETCH_SUCCESS,
  SEARCH_HELP_LIST_FETCH_FAIL
} from '../actions';

export const changeLocale = (locale) => {
  localStorage.setItem('currentLanguage', locale);
  return (
    {
      type: CHANGE_LOCALE,
      payload: locale
    }
  )
}

/* category */
export const allCategoryFetch = (allCategory) => ({
  type: ALL_CATEGORY_FETCH,
  payload: { allCategory }
})
export const allCategoryFetchSuccess = (allCategory) => ({
  type: ALL_CATEGORY_FETCH_SUCCESS,
  payload: { allCategory }
})
export const allCategoryFetchFail = (message) => ({
  type: ALL_CATEGORY_FETCH_FAIL,
  payload: { message }
})


/*external category */
export const externalCategoryFetch = (externalCategory) => ({
  type: EXTERNAL_CATEGORY_FETCH,
  payload: { externalCategory }
})
export const externalCategoryFetchSuccess = (externalCategory) => ({
  type: EXTERNAL_CATEGORY_FETCH_SUCCESS,
  payload: { externalCategory }
})
export const externalCategoryFetchFail = (message) => ({
  type: EXTERNAL_CATEGORY_FETCH_FAIL,
  payload: { message }
})

/* sub category */
export const allSubcategoryFetch = (allSubcategory) => ({
  type: ALL_SUBCATEGORY_FETCH,
  payload: { allSubcategory }
})
export const allSubcategoryFetchSuccess = (allSubcategory) => ({
  type: ALL_SUBCATEGORY_FETCH_SUCCESS,
  payload: { allSubcategory }
})
export const allSubcategoryFetchFail = (message) => ({
  type: ALL_SUBCATEGORY_FETCH_FAIL,
  payload: { message }
})

/* help */
export const HelpDataFetch = (HelpData) => ({
  type: HELP_FETCH,
  payload: { HelpData }
})
export const HelpDataFetchSuccess = (HelpData) => ({
  type: HELP_FETCH_SUCCESS,
  payload: { HelpData }
})
export const HelpDataFetchFail = (message) => ({
  type: HELP_FETCH_FAIL,
  payload: { message }
})

/* help detail */
export const HelpDetailDataFetch = (HelpDetailData) => ({
  type: HELP_DETAIL_FETCH,
  payload: { HelpDetailData }
})
export const HelpDetailDataFetchSuccess = (HelpDetailData) => ({
  type: HELP_DETAIL_FETCH_SUCCESS,
  payload: { HelpDetailData }
})
export const HelpDetailDataFetchFail = (message) => ({
  type: HELP_DETAIL_FETCH_FAIL,
  payload: { message }
})

/* policy */
export const policyListFetch = (policyList) => ({
  type: POLICY_LIST_FETCH,
  payload: { policyList }
})
export const policyListFetchSuccess = (policyList) => ({
  type: POLICY_LIST_FETCH_SUCCESS,
  payload: { policyList }
})
export const policyListFetchFail = (message) => ({
  type: POLICY_LIST_FETCH_FAIL,
  payload: { message }
})

/* search help */
export const searchHelpListFetch = (searchHelpList) => ({
  type: SEARCH_HELP_LIST_FETCH,
  payload: { searchHelpList }
})
export const searchHelpListFetchSuccess = (searchHelpList) => ({
  type: SEARCH_HELP_LIST_FETCH_SUCCESS,
  payload: { searchHelpList }
})
export const searchHelpListFetchFail = (message) => ({
  type: SEARCH_HELP_LIST_FETCH_FAIL,
  payload: { message }
})